import * as React from 'react'
import Toggle from 'src/components/ui/Toggle'
import { IServicePricingType } from 'src/types'
import { sortByProperty } from 'src/utils/array-helper'

interface ServiceViewPassengerTypeProps {
  orgId: string
  serviceId: string
  // pricingType: Array<{ serviceId: string, id: string; riderType: string; description: string; fare: number; }>
  pricingType: IServicePricingType[]
  fetchServicePricingType: (serviceId: string) => void
}

export const ServiceViewPassengerType = (props: ServiceViewPassengerTypeProps) => {
  const [pricing, setPricing] = React.useState([] as IServicePricingType[])

  React.useEffect(() => {
    props.fetchServicePricingType(props.serviceId)
    console.log('A', props)
    console.log('B', props.pricingType)
  }, [props.serviceId])

  React.useEffect(() => {
    setPricing(sortByProperty(props.pricingType, 'riderType'))
  }, [props.pricingType])

  if (props.serviceId) {
    return (
      <div className='react-table'>
        <div className='react-table'>
          <div className='flex col-12 mt1'>
            <span className='col-2 font-dark-grey h5 weight-500 mr2'>
              <b>Active</b>
            </span>
            <span className='col-8 font-dark-grey h5 weight-500 mr2'>
              <b>Rider Type</b>
            </span>
            <span className='col-8 font-dark-grey h5 weight-500 mr2'>
              <b>Description</b>
            </span>
            <span className='col-8 font-dark-grey h5 weight-500 mr2'>
              <b>Fare</b>
            </span>
          </div>
          {pricing.map(items => {
            return (
              <div className='flex col-12 mt1' key={items.id}>
                <span className='col-2 font-dark-gray h5 weight-500 mr2'>
                  <Toggle state={items.isActive} onClick={() => void 0} />
                </span>
                <span className='col-8 font-dark-grey h5 weight-500 mr2'>
                  {items.riderType ? items.riderType : 'No data'}
                </span>
                <span className='col-8 font-dark-grey h5 weight-500 mr2'>
                  {items.description ? items.description : 'No data'}
                </span>
                <span className='col-8 font-dark-grey h5 weight-500 mr2'>{items.fare ? items.fare : 'No data'}</span>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  return <div />
}

export default ServiceViewPassengerType



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewPassengerType.tsx